module.exports = __webpack_public_path__ + "img/undertakingCases11.c83f678e.jpg";